import React from 'react';
import { Toast, ToastType } from './Toast';

export interface ToastItem {
	id: string;
	message: string;
	type: ToastType;
}

interface ToastContainerProps {
	toasts: ToastItem[];
	onRemove: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {
	return (
		<div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-md">
			{toasts.map((toast) => (
				<Toast key={toast.id} message={toast.message} type={toast.type} onClose={() => onRemove(toast.id)} />
			))}
		</div>
	);
};
